// Same as loader-globals.ts except includes all additional extension loaders
import './all-external-dependencies'
import './lazy-recorder'
import './array.no-external'
